import type { LocationQuery } from 'vue-router';

// A repeated parameter arrives as an array and a single one as a string.
// The array is refused rather than picked from.
export function singleQueryValue(query: LocationQuery, param: string): string | undefined {
  const raw = query[param];
  return typeof raw === 'string' && raw !== '' ? raw : undefined;
}
